<template>
    <div class="modal-container">
        <div class="modal-header">
            <span v-if="selectedCustomField === null">Add Shipment Custom Field</span>
            <span v-if="selectedCustomField !== null">Edit {{ selectedCustomField.label }}</span>
            <md-button class="md-simple md-just-icon md-round modal-default-button" @click.stop="$modal.hide">
                <md-icon>clear</md-icon>
            </md-button>
        </div>
        <div class="modal-body">
            <form-wrapper :validator="$v.form" class="form-wrapper">
                <form-group v-if="selectedCustomField !== null" label="Id" name="label">
                    <md-input v-model="form.name" disabled />
                </form-group>
                <form-group label="Label" name="label">
                    <md-input v-model="form.label" />
                </form-group>
                <form-group name="type">
                    <vue-select
                        v-if="customFieldTypes"
                        :options="customFieldTypes"
                        placeholder="Type"
                        v-model="form.type"
                    ></vue-select>
                </form-group>

                <div>
                    <md-checkbox v-model="form.isRequired">
                        Required
                    </md-checkbox>
                </div>
                <div>
                    <md-checkbox v-model="form.includeInPodPdf">
                        Include in Proof Of Delivery PDF
                    </md-checkbox>
                </div>
            </form-wrapper>
        </div>
        <div class="modal-footer">
            <md-button
                v-if="selectedCustomField === null"
                class="dialog-button md-primary"
                @click="addShipmentCustomField"
            >
                Add
            </md-button>
            <md-button
                v-if="selectedCustomField !== null"
                class="dialog-button md-primary"
                @click="editShipmentCustomField"
            >
                Save
            </md-button>
            <md-button class="dialog-button md-default" @click.stop="$modal.hide">
                Cancel
            </md-button>
        </div>
    </div>
</template>

<script>
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { required } from 'vuelidate/lib/validators';
import { CUSTOM_FIELD_TYPES_CONSTANTS } from '@/utils/constants';

export default {
    name: 'ShipmentCustomFieldModal',
    mixins: [GeneralMixin],
    props: {
        selectedCustomField: {
            type: Object,
            default: null
        },
        resolve: {
            type: Function,
            default: () => {}
        }
    },
    data() {
        return {
            form: {
                name: '',
                label: '',
                type: '',
                isRequired: false,
                includeInPodPdf: false
            },
            customfield: {},
            customFieldTypes: CUSTOM_FIELD_TYPES_CONSTANTS
        };
    },
    mounted() {
        if (this.selectedCustomField !== null) {
            this.form.name = this.selectedCustomField.name;
            this.form.label = this.selectedCustomField.label;
            this.form.type = this.selectedCustomField.type;
            this.form.isRequired = this.selectedCustomField.isRequired;
            this.form.includeInPodPdf = this.selectedCustomField.includeInPodPdf;
            this.form.assetType = this.selectedCustomField.assetType;
        }
    },
    methods: {
        addShipmentCustomField() {
            this.$v.form.$touch();
            if (!this.$v.form.$invalid) {
                this.customfield = {
                    name: this.form.label.toLowerCase().replace(/[^\w]/gi, ''),
                    label: this.form.label,
                    type: this.form.type,
                    isRequired: this.form.isRequired,
                    includeInPodPdf: this.form.includeInPodPdf
                };
                this.resolve(this.customfield);
            }
        },
        editShipmentCustomField() {
            this.$v.form.$touch();
            if (!this.$v.form.$invalid) {
                this.customfield = Object.assign({}, this.form);
                this.resolve(this.customfield);
            }
        }
    },
    validations: {
        form: {
            label: {
                required
            },
            type: {
                required
            }
        }
    }
};
</script>
